import React from 'react';
import { Box } from '@mui/material';

import { FilterProvider } from 'src/components/app/context/FilterContext';
import { useSection } from 'src/components/app/context/SectionContext';
import { useUserContext } from 'src/components/app/context/UserContext';
import FilterDisplay from 'src/components/common/FilterDisplay';
import PageFrame from 'src/components/common/PageFrame';
import useInitialFilterGroups from 'src/components/followUp/hooks/useInitialFilterGroups';

import Sidebar from '../FilterColumn/Sidebar';
import TicketFilterProvider from '../TicketFilterContext';

import TicketTable from './TicketTable/TicketTable';
import TicketsDownloadButton from './TicketsDownloadButton';

export const TicketOverviewPage = () => {
  const { currentSurvey } = useUserContext();
  const { moduleId } = useSection();
  const { initialFilterGroups, initialFilterSpecs } = useInitialFilterGroups({
    dateRange: true,
  });

  return (
    <FilterProvider
      key={`${currentSurvey?.id}:${moduleId}`}
      allowCombinedFilters
      initialFilterGroups={initialFilterGroups}
      initialFilterSpecs={initialFilterSpecs}
    >
      <TicketFilterProvider>
        <PageFrame sidebar={<Sidebar />}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: '100%',
            }}
          >
            <Box
              sx={(theme) => ({
                display: 'flex',
                marginInline: theme.spacing(4),
                justifyContent: 'space-between',
                // Prevent the download button from stretching vertically when
                //  the filter display is expanded:
                alignItems: 'start',
              })}
            >
              <FilterDisplay
                withShowMoreButton
                formatLabel={(name, values) =>
                  `${name}: ${values.map((value) => value.label).join(', ')}`
                }
              />

              <TicketsDownloadButton
                // Prevent button from shrinking when the FilterDisplay is expanded and takes up a lot of width:
                sx={{ flexShrink: 0 }}
              />
            </Box>

            <TicketTable />
          </Box>
        </PageFrame>
      </TicketFilterProvider>
    </FilterProvider>
  );
};
